"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.fetchBrandDomains = exports.fetchBlogDomains = exports.fetchDomains = void 0;

var _reduxObservable = require("redux-observable");

var _RequestStatusTypes = _interopRequireDefault(require("settings-ui-sdk/constants/RequestStatusTypes"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-ui-sdk/RequestEpicDescriptor"));

var _requestEntity = _interopRequireDefault(require("settings-ui-sdk/requestEntity"));

var _actions = require("settings-ui-sdk/Domains/actions");

var _selectors = require("./selectors");

var _API = _interopRequireDefault(require("./API"));

var fetchDomains = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getDomains,
  initiatingActionType: _actions.DomainActionTypes.LOAD_DOMAINS,
  requestStatusSelector: _selectors.getFetchDomainsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchDomains
}));
exports.fetchDomains = fetchDomains;
var fetchBlogDomains = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getDomainsForBlogs,
  initiatingActionType: _actions.DomainActionTypes.LOAD_BLOG_DOMAINS,
  requestStatusSelector: _selectors.getFetchBlogDomainsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchBlogDomains
}));
exports.fetchBlogDomains = fetchBlogDomains;
var fetchBrandDomains = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.getBrandDomains,
  initiatingActionType: _actions.DomainActionTypes.LOAD_BRAND_DOMAINS,
  requestStatusSelector: _selectors.getFetchBrandDomainsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchBrandDomains
}));
exports.fetchBrandDomains = fetchBrandDomains;

var _default = (0, _reduxObservable.combineEpics)(fetchDomains, fetchBlogDomains, fetchBrandDomains);

exports.default = _default;